

import createjs, { Shape } from 'createjs-module'
import {CanvasMouseTracker} from '../../../../../com/canvas/mouseTracker/CanvasMouseTracker'
import { Dimensions } from '../../../../../globals/Dimensions';



export class SpotSelectedLayer extends createjs.Container {
    
    private _topLeftRect: createjs.Shape;
    private _topRightRect: createjs.Shape;
    private _bottomLeftRect: createjs.Shape;
    private _bottomRightRect: createjs.Shape;

    private _canvasMouseTracker: CanvasMouseTracker | null = null;
    
    constructor() {
        super()

        this.addEventListener('added', this.onAddedToStage.bind(this));
        this.addEventListener('removed', this.onRemovedFromStage.bind(this));
        
        let width = 11;
        let height = 11;

        //
        this._topLeftRect = this.createShape(width, height)
        this._topRightRect = this.createShape(width, height)
        this._bottomLeftRect = this.createShape(width, height)
        this._bottomRightRect = this.createShape(width, height)

        //
        this.addChild(this._topLeftRect)
        this.addChild(this._topRightRect)
        this.addChild(this._bottomLeftRect)
        this.addChild(this._bottomRightRect)

        // this._mouseIconManager.trackIcon("", "", this._topLeftRect);
        // this._mouseIconManager.trackIcon("", "", this._topRightRect);
        // this._mouseIconManager.trackIcon("", "", this._bottomLeftRect);
        // this._mouseIconManager.trackIcon("", "", this._bottomRightRect);

    }

    private onAddedToStage(event: any){
        if (event.target.stage != null) {
            this._canvasMouseTracker = new CanvasMouseTracker(this.stage);
            // this._canvasMouseTracker.addIcon('framesGridCreationIcon', framesGridCreationIcon)
        }
    }

    private onRemovedFromStage(){
        
    }

    private createShape(width: number, height: number){
        let shape = new createjs.Shape();

        shape
            .graphics
            .setStrokeStyle(1) 
            .beginStroke("#18A0FB")
            .beginFill("#FFFFFF")
            .drawRect(0, 0, width, height)
            .endFill();

        shape.setBounds(0, 0, width, height)

        return shape;
    }

    public updatePosition(parentWidth: number, parentHeight: number) {
        this._topLeftRect.x = -this._topLeftRect.getBounds().width * 0.5
        this._topLeftRect.y = -this._topLeftRect.getBounds().height * 0.5

        this._topRightRect.x = parentWidth  - this._topRightRect.getBounds().width * 0.5
        this._topRightRect.y = - this._topRightRect.getBounds().height * 0.5

        this._bottomLeftRect.x = - this._bottomLeftRect.getBounds().width * 0.5
        this._bottomLeftRect.y = parentHeight - this._bottomLeftRect.getBounds().height * 0.5

        this._bottomRightRect.x = parentWidth  - this._bottomRightRect.getBounds().width * 0.5
        this._bottomRightRect.y = parentHeight - this._bottomRightRect.getBounds().height * 0.5
    }

    setVisible(value: boolean) {
        this.visible = value;
        this.topLeftRect.visible = value;
        this.topRightRect.visible = value;
        this.bottomLeftRect.visible = value;
        this.bottomRightRect.visible = value;
    }

    public get topLeftRect(): createjs.Shape {
        return this._topLeftRect;
    }

    public get topRightRect(): createjs.Shape {
        return this._topRightRect;
    }

    public get bottomLeftRect(): createjs.Shape {
        return this._bottomLeftRect;
    }

    public get bottomRightRect(): createjs.Shape {
        return this._bottomRightRect;
    }
}